import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=b3128dc4&scoped=true&"
import script from "./HomeAbout.vue?vue&type=script&lang=ts&"
export * from "./HomeAbout.vue?vue&type=script&lang=ts&"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=b3128dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3128dc4",
  null
  
)

export default component.exports